// import InputImage from "utils/InputImage.tsx";

import { BsBasket2, BsCreditCard2Back } from "react-icons/bs";
import {
  HiOutlineLocationMarker,
  HiOutlineClipboardList,
} from "react-icons/hi";
import { IoSettingsOutline } from "react-icons/io5";
import { CgExtensionAdd } from "react-icons/cg";
import logo from "../../../assets/images/logo/Sabadi.svg";
// import logo from "../../assets/images/aHR0cHM6Ly9zY29udGVudC1vcnQyLTEuY2RuaW5zdGFncmFtLmNvbS92L3Q1MS4yODg1LTE5LzI0MTI1OTg2OF84MDYxMzU0MjAwNjAxODlfNTE5MzY1OTQ5OTE0MjAyNTY5OV9uLmpwZz9zdHA9ZH.jpg";

export default function SidePanel({
  otherInfo = { title: "", address: "" },
  logos = "",
}) {
  console.log("object", logos);
  // console.log("logo", logos);
  // console.log(otherInfo, "otherInfo is :");
  // function uploadLogoHandler() {
  //   console.log("Upload Logo");
  // }
  // console.log("info", otherInfo);

  return (
    <>
      <div className="side-panel-container d-flex align-items-center justify-content-around">
        <div className="title-container d-flex justify-content-center align-items-center">
          {/* سایدبار */}
          <div className="image-input text-center d-flex align-items-center justify-content-center shadow rounded-pill">
            {/* -------- */}
            {logos != "" ? (
              <img
                src={`https://sabadi.ir/api/${logos}`}
                className="w-100 "
                style={{ borderRadius: "50%" }}
              />
            ) : (
              <img src={logo} style={{ width: "120px", height: "120px" }} />
            )}
            {/* <img src={logo} style={{ width: "120px", height: "120px" }} /> */}
            {/* --------- */}
          </div>
          <div className="mt-3 text-center">
            <h5>{otherInfo.title}</h5>
            {/* <br /> */}
            <HiOutlineLocationMarker className="me-1" />
            {otherInfo.address}&nbsp;
          </div>
        </div>
        <hr
          className="d-none d-md-block"
          style={{ color: "#1A3764", width: "80%" }}
        />
        <ul className="nav nav-pills my-3 d-flex" id="pills-tab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active d-flex align-items-center"
              id="pills-setting-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-setting"
              type="button"
              role="tab"
              aria-controls="pills-setting"
              aria-selected="true"
            >
              <p className="icon-container">
                {" "}
                <IoSettingsOutline color="tomato" className="icon" />
              </p>

              <p className="ms-3">تنظیمات</p>
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link d-flex align-items-center"
              id="pills-define-product-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-define-product"
              type="button"
              role="tab"
              aria-controls="pills-define-product"
              aria-selected="false"
            >
              <p className="icon-container">
                <CgExtensionAdd className="icon" color="tomato" />
              </p>

              <p className="ms-3"> تعریف کالا</p>
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link d-flex align-items-center"
              id="pills-orders-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-orders"
              type="button"
              role="tab"
              aria-controls="pills-orders"
              aria-selected="false"
            >
              <p className="icon-container">
                <HiOutlineClipboardList className="icon" color="tomato" />
              </p>
              <p className="ms-3"> سفارشات</p>
            </button>
          </li>
          {/* <li className="nav-item" role="presentation">
            <button
              className="nav-link d-flex align-items-center"
              id="pills-basket-maker-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-basket-maker"
              type="button"
              role="tab"
              aria-controls="pills-basket-maker"
              aria-selected="false"
            >
              <p className=" icon-container align-self-center">
                {" "}
                <BsBasket2
                  className="icon"
                  color="tomato"
                  // style={{ color: "navy", width: "20px", height: "20px" }}
                />
              </p>

              <p className="ms-3 ">سبد ساز</p>
            </button>
          </li> */}
          <li className="nav-item" role="presentation">
            <button
              className="nav-link d-flex align-items-center"
              id="pills-finance-button"
              data-bs-toggle="pill"
              data-bs-target="#pills-finance"
              type="button"
              role="tab"
              aria-controls="pills-finance"
              aria-selected="false"
            >
              <p className="icon-container">
                <BsCreditCard2Back
                  color="tomato"
                  className="icon"
                  // style={{ color: "#395279", width: "35px", height: "35px" }}
                />
              </p>

              <p className="ms-3">امورمالی</p>
            </button>
          </li>
        </ul>
      </div>
    </>
  );
}
